import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { CustomTableReportEquipmentLogbook } from 'src/app/interfaces/custom-table-report-equipment-logbook/custom-table-report-equipment-logbook.interface';
import { PrintGroupPaginatorService } from 'src/app/services/global-services/print-group-paginator.service';

@Component({
  selector: 'app-custom-table-report-equipment-logbook',
  templateUrl: './custom-table-report-equipment-logbook.component.html',
  styleUrls: ['./custom-table-report-equipment-logbook.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonModule, TableModule, DropdownModule, FormsModule],
  providers: [ConfirmationService]
})
export class CustomTableReportEquipmentLogbookComponent implements OnChanges, OnInit {

  @Input() dataReport: CustomTableReportEquipmentLogbook;
  @Input() isValued: boolean = false;
  @Input() filtersHeight: number = 0;
  @Input() extraMargin: number = 60;
  @Input() printBreakDepth: number = -1;

  @ViewChild('headerContainer') headerContainer!: ElementRef;

  scrollHeight: string = '0px';

  constructor(
    private cdr: ChangeDetectorRef,
    private printGroupPaginatorService: PrintGroupPaginatorService,
    private el: ElementRef
  ) { }

  ngOnInit() {
    this.updateScrollHeight();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filtersHeight']) {
      this.updateScrollHeight();
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.updateScrollHeight();
  }

  @HostListener('window:beforeprint')
  onBeforePrint() {
    if (this.printBreakDepth < 0) return;
    this.printGroupPaginatorService.restructure(this.el.nativeElement, this.printBreakDepth);
  }

  @HostListener('window:afterprint')
  onAfterPrint() {
    if (this.printBreakDepth < 0) return;
    this.printGroupPaginatorService.revert(this.el.nativeElement);
  }

  private updateScrollHeight() {
    setTimeout(() => {
      this.scrollHeight = `${window.innerHeight - this.filtersHeight - this.extraMargin}px`;
      this.cdr.detectChanges();
    }, 100);
  }

  alignColumnText(value: any): string {
    if (this.isDecimal(value)) return 'right';

    if (this.isValidDate(value)) return 'center';

    if (typeof value === 'string') return 'left';

    if (isNaN(Number(value))) return 'left';

    return 'center'
  }

  getBackgroundColor(depth: number): string {
    const startColor = [200, 200, 200];
    const endColor = [244, 244, 244];

    const r = Math.round(startColor[0] + (endColor[0] - startColor[0]) * (depth / 3));
    const g = Math.round(startColor[1] + (endColor[1] - startColor[1]) * (depth / 3));
    const b = Math.round(startColor[2] + (endColor[2] - startColor[2]) * (depth / 3));

    return `rgb(${r}, ${g}, ${b})`;
  }

  isDecimal(value: any): boolean {
    const includesDot = value?.toString()?.includes('.');

    if (!includesDot) return false;
    if (isNaN(Number(value))) return false;

    return true;
  }

  isValidDate(value: any): boolean {
    if (!value || typeof value !== 'string') return false;

    return moment(value, ['DD/MM/YYYY', 'DD-MM-YYYY'], true).isValid();
  }
}
